import { Applications } from "../types/Applications";

/**
 * Pure validation for the Application Approval modal (CREDIT-39 AC3).
 *
 * Returns the first blocking validation message, or null when the approval may be
 * submitted. Extracted from ApprovalDialog so the rules are unit-testable and stay in
 * sync with the backend checks in ApplicationController.SetApplication.
 */
export function validateApproval(
   application: Applications,
   maximumApprovalAmount: number,
): string | null {
   const companiesRequiringCompanyCode = ["UWL", "WDS"];

   const currentCompanyRequiresCompanyCode = companiesRequiringCompanyCode.some((company) =>
      (application.applicationNumber || "").includes(company),
   );

   if (currentCompanyRequiresCompanyCode && !application.companyCode) {
      return "You must enter a customer code!";
   }

   if (application.status === "APPROVED") {
      return "You cannot edit because the application has already been approved!";
   }

   if (application.status === "DENIED") {
      return "You cannot edit because the application has already been denied!";
   }

   if (!application.approvedAmount) {
      return "You must enter an approved amount!";
   }

   if (!application.netTerms) {
      return "You must enter the net terms!";
   }

   if (application.contacts.length === 0) {
      return "You must select at least one contact!";
   }

   if (application.approvedAmount > maximumApprovalAmount) {
      return `Access to approve the application amount is denied! Maximum allowed is: $${maximumApprovalAmount.toLocaleString(
         undefined,
         { maximumFractionDigits: 0 },
      )}`;
   }

   return null;
}
